import {css} from '@emotion/css';

export function makeStyles() {
    return css`
        display: flex;
        padding: 10px;
        justify-content: center;
        .k-btn {
            height: 40px;
            font-size: 16px;
        }
    `
}
